import { MgoObjectResponse } from '@mgonetwork/mango.js/client';

export const hasDisplayData = (obj: MgoObjectResponse) => !!obj.data?.display?.data;
